import { z } from "zod";
import { ROLES } from "../enums";
import { emailSchema, passwordSchema } from "./common";

export const signupSchema = z.object({
  name: z.string().trim().min(2, "Nom trop court").max(120),
  email: emailSchema,
  password: passwordSchema,
  organizationName: z.string().trim().min(2, "Nom trop court").max(120),
  clientName: z.string().trim().min(2, "Nom trop court").max(120).optional(),
  marketCode: z.string().length(2).toUpperCase().default("TN"),
});
export type SignupInput = z.infer<typeof signupSchema>;

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, "Mot de passe requis").max(128),
  totp: z
    .string()
    .regex(/^\d{6}$/, "Code à 6 chiffres")
    .optional(),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({
  token: z.string().min(20).max(200),
  password: passwordSchema,
});
export const verifyEmailSchema = z.object({ token: z.string().min(20).max(200) });
export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(128),
  newPassword: passwordSchema,
});
export const updateProfileSchema = z.object({
  name: z.string().trim().min(2).max(120).optional(),
  avatarUrl: z.string().url().max(500).nullable().optional(),
  locale: z.enum(["fr", "en", "ar"]).optional(),
});
export const totpCodeSchema = z.object({ code: z.string().regex(/^\d{6}$/, "Code à 6 chiffres") });

export const inviteMemberSchema = z.object({
  email: emailSchema,
  role: z.enum(ROLES).refine((r) => r !== "owner", "Rôle non autorisé"),
  clientIds: z.array(z.string().regex(/^[a-f0-9]{24}$/i)).optional(),
});
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;

export const acceptInvitationSchema = z.object({
  token: z.string().min(20).max(200),
  name: z.string().trim().min(2).max(120).optional(),
  password: passwordSchema.optional(),
});

export const updateMemberSchema = z.object({
  role: z.enum(ROLES).optional(),
  clientIds: z.array(z.string().regex(/^[a-f0-9]{24}$/i)).nullable().optional(),
  aiMonthlyTokenLimit: z.number().int().min(0).nullable().optional(),
});
